module.exports = __webpack_public_path__ + "static/media/profile.d9046088.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/user/profile.png
// module id = 673
// module chunks = 0